import { Component, Input,OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BindComponentService } from '../../../../utils/bind.component.service';
import { Subject } from 'rxjs/Subject';
/**
 * @version $Id$
 */
@Component({
  selector: 'configureSyncLeavePage',
  templateUrl: './content.template.html'
})
export class ConfigureSyncLeavePage implements OnInit {

  subject: Subject<boolean>;
  response: boolean;

  constructor(private bindComponent: BindComponentService, private activeModal: NgbActiveModal) {

  }

  ngOnInit() {
  }

  private cancel() {
    this.activeModal.close('cancel');
  }

  private save() {
    this.activeModal.close('save');
  }

  private leave() {
    this.activeModal.close('leave');
  }
}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/vivosync/configureLeavePage/content.component.ts